import VueCountdown from '@xkeshi/vue-countdown';

export default {
	install(Vue){
		Vue.component('countdown', VueCountdown);
	}
}